// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"333":"a5f08a1d4baccfb9","650":"e5aa241453197f23"}[chunkId] + ".js";
};